// Constantes & helpers visuels de l'application

// Couleurs pour les différents types et environnements (alignées sur wheere-integrator)
export const COLORS = {
  primary: '#ED107D',
  types: {
    tracker: '#ED107D',   // primary pink
    gateway: '#ffc800',   // warmYellow
    default: '#6b7280',   // gray-500
  },
  environments: {
    dev: '#23d2cd',       // aquamarine
    qualif: '#5000cd',    // eletricPurple
    prod: '#5DA24B',      // green
    default: '#6b7280',
  },
}

export const DEVICE_TYPES = [
  { value: 'tracker', label: 'Tracker' },
  { value: 'gateway', label: 'Gateway' },
]

export const ENVIRONMENTS = [
  { value: 'dev', label: 'Développement' },
  { value: 'qualif', label: 'Qualification' },
  { value: 'prod', label: 'Production' },
]

export const ENV_LABELS = {
  dev: 'Développement',
  qualif: 'Qualification',
  prod: 'Production',
  other: 'Autre',
}

// ── Helpers couleur ──────────────────────────────────────────────────────────
export function envColor(env) {
  return COLORS.environments[env] || COLORS.environments.default
}
export function typeColor(type) {
  return type ? COLORS.types[type] || COLORS.types.default : COLORS.types.default
}

function hexAlpha(hex, alpha) {
  const h = hex.replace('#', '')
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h
  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

// Style "chip soft" (fond teinté léger + texte coloré + ring) — look integrator
export function softStyle(hex) {
  return {
    color: hex,
    backgroundColor: hexAlpha(hex, 0.12),
    boxShadow: `inset 0 0 0 1px ${hexAlpha(hex, 0.3)}`,
  }
}
